
// Dynamic assets path override
!function() {
__webpack_require__.p = (function findDomainAndSetWebpackPublicPath(fileName) {
  var documentScripts = document.getElementsByTagName('script');
  for (var i = 0; i < documentScripts.length; i++) {
    var src = documentScripts[i].src;
    var regex = new RegExp('(.*)(' + fileName + ')$');
    if (regex.test(src)) {
      return src.match(regex)[1];
    }
  }
  return null;
})('browse-desktop-8d23a3d1eb.js') || __webpack_require__.p;
}();

